import { Box } from '@chakra-ui/layout';
import {
    UnorderedList,
    ListItem
} from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';

import { Button } from '../../../../components/three-essentials/button/button';
import { RouteContainer } from '../../../helpers/styled';
import {
    Container,
    IconContainer,
    IconWrapper,
    IconSvg,
    Title,
    ContentWrapper,
    Description
} from './one-roaster-landing-page.styled';
import { Module } from '@api';
import {
    TeacherAdminIcon,
    TeacherAdminIcons
} from '@components';

type OneRoasterLandingPageProps = {
moduleInfo: Module
};

export const OneRoasterLandingPage = ({ moduleInfo }: OneRoasterLandingPageProps) => {
    if(!moduleInfo) return null;

    const getDescription = () => {
        const containsNewlineCharacter = moduleInfo.description.includes('\n');

        if (containsNewlineCharacter) {
            const description = moduleInfo.description.split('\n');

            return <UnorderedList>{description.map((desc) => <ListItem key={desc}>{desc}</ListItem>)}</UnorderedList>;
        }

        return moduleInfo.description;
    };
    const clickHandler = () => {
        window.open(moduleInfo.moduleLink, moduleInfo.target);
    };

    return (
        <RouteContainer>
            <Box width={'100%'} data-testid={'one-roaster-landing-page'}>
                <Container>
                    <IconContainer>
                        <IconWrapper>
                            <IconSvg>
                                <TeacherAdminIcon
                                    icon={moduleInfo.icon as TeacherAdminIcons}
                                    width={45}
                                />
                            </IconSvg>
                        </IconWrapper>
                    </IconContainer>
                    <ContentWrapper>
                        <Title>{moduleInfo.group}</Title>
                        <Description>{getDescription()}</Description>
                        <Button
                            title={t`threeEssentials.manage`}
                            clickHandler={clickHandler}
                        />
                    </ContentWrapper>
                </Container>
            </Box>
        </RouteContainer>
    );
};
